//export const authHeader: string =
export default function authHeader() {
     // return authorization header with jwt token
     const token: any = localStorage.getItem('user');
     if (!token) {
         return '';
     }
 
     const user = JSON.parse(token);
     if (user) {
         return 'Bearer ' + user.token;
     } else {
         return '';
     }
 }